import createAction from 'loankeeper-common/helpers/createAction'
import { actions, factoryActions } from './constants'

/**
 * Action to choose active tab
 *
 * @param {string} toTab
 * @returns {object}
 */
export const chooseActiveTabById = ({ tab, hash, ID, type, firstSwitch }) =>
  createAction(
    actions.SWITCH_TAB,
    {
      ID,
      hash,
      tab,
      firstSwitch,
    },
    { type, ID },
  )

export const fetchPage = (args, callback) =>
  createAction(actions.data.FETCH, args, {
    type: args.type,
    ID: args.ID,
    permission: args.permission,
    callback,
  })

export const fetchSuccess = ({ page, data, type, ID }) =>
  createAction(actions.data.FETCH_SUCCESS, { page, data }, { type, ID })

export const registerById = (type, ID) =>
  createAction(
    factoryActions.REGISTER,
    {},
    {
      type,
      ID,
    },
  )

export const unregisterById = (type, ID) =>
  createAction(
    factoryActions.UNREGISTER,
    {},
    {
      type,
      ID,
    },
  )

export const resetTabById = (type, ID, page) =>
  createAction(
    actions.RESET_TAB,
    {
      page,
    },
    {
      type,
      ID,
    },
  )

// TODO: somehow remove this clearErrors action
export const clearErrors = () => createAction(actions.CLEAR_ERRORS)
